import { useEffect } from "react"

import {
	useNotificationActions,
	useUnreadNotifications,
} from "./use-notifications"

/** Opening a thread reads its notifications. Uses the already-synced unread rows, so no extra query. */
export function useMarkThreadNotificationsRead(threadId: string | undefined) {
	const { rows } = useUnreadNotifications()
	const { markThreadRead } = useNotificationActions()
	const hasUnread = Boolean(
		threadId && rows.some((r) => r.threadId === threadId),
	)

	useEffect(() => {
		if (!threadId || !hasUnread) return
		markThreadRead(threadId).catch(() => undefined)
	}, [threadId, hasUnread, markThreadRead])
}
